import React, { useState, useRef, useEffect } from 'react';
import { exportarCSV, exportarXLSX } from '../utils/exportReporte';

const ExportButton = ({ docs, nombreArchivo, rangoDesde, rangoHasta }) => {
  const [open,       setOpen]       = useState(false);
  const [exportando, setExportando] = useState(false);
  const ref = useRef(null);

  /* Cerrar menú al hacer click fuera */
  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const handleCSV = () => {
    setOpen(false);
    exportarCSV(docs, nombreArchivo);
  };

  const handleXLSX = async () => {
    setOpen(false);
    setExportando(true);
    try {
      await exportarXLSX(docs, nombreArchivo, rangoDesde, rangoHasta);
    } catch (e) {
      console.error('Error exportando XLSX:', e);
      alert('Error al generar el archivo. Intenta con CSV.');
    } finally {
      setExportando(false);
    }
  };

  return (
    <div ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
      <button
        onClick={() => setOpen((v) => !v)}
        disabled={exportando || docs.length === 0}
        style={{
          alignItems    : 'center',
          background    : docs.length === 0 ? 'var(--color-background-secondary)' : '#fff',
          border        : '0.5px solid var(--color-border-secondary)',
          borderRadius  : 'var(--border-radius-md)',
          color         : docs.length === 0 ? 'var(--color-text-secondary)' : 'var(--color-text-primary)',
          cursor        : docs.length === 0 ? 'not-allowed' : 'pointer',
          display       : 'flex',
          fontSize      : '12px',
          fontWeight    : 500,
          gap           : '6px',
          padding       : '6px 14px',
          transition    : 'all .15s',
          whiteSpace    : 'nowrap',
        }}
      >
        {exportando ? (
          <>
            <span style={{ width:'13px',height:'13px',border:'2px solid #d1d5db',borderTop:'2px solid #04afaa',borderRadius:'50%',animation:'spin .7s linear infinite',display:'inline-block' }}/>
            Generando…
          </>
        ) : (
          <>
            <i className="ti ti-download" style={{ fontSize:'14px' }} aria-hidden="true"/>
            Exportar
            <span style={{ fontSize:'10px', color:'var(--color-text-secondary)' }}>({docs.length})</span>
            <i className="ti ti-chevron-down" style={{ fontSize:'12px' }} aria-hidden="true"/>
          </>
        )}
      </button>

      {open && (
        <div style={{
          background   : '#fff',
          border       : '0.5px solid var(--color-border-secondary)',
          borderRadius : 'var(--border-radius-md)',
          boxShadow    : '0 4px 16px rgba(0,0,0,.12)',
          minWidth     : '160px',
          position     : 'absolute',
          right        : 0,
          top          : 'calc(100% + 4px)',
          zIndex       : 100,
          overflow     : 'hidden',
        }}>
          <button onClick={handleXLSX} style={menuItemStyle}>
            <span style={{ fontSize:'16px' }}>📊</span>
            <div>
              <div style={{ fontWeight:500, fontSize:'12px' }}>Excel (.xlsx)</div>
              <div style={{ fontSize:'11px', color:'var(--color-text-secondary)' }}>Con formato y colores</div>
            </div>
          </button>
          <div style={{ height:'0.5px', background:'var(--color-border-tertiary)' }}/>
          <button onClick={handleCSV} style={menuItemStyle}>
            <span style={{ fontSize:'16px' }}>📄</span>
            <div>
              <div style={{ fontWeight:500, fontSize:'12px' }}>CSV (.csv)</div>
              <div style={{ fontSize:'11px', color:'var(--color-text-secondary)' }}>Compatible con cualquier app</div>
            </div>
          </button>
        </div>
      )}
    </div>
  );
};

const menuItemStyle = {
  alignItems  : 'center',
  background  : 'transparent',
  border      : 'none',
  cursor      : 'pointer',
  display     : 'flex',
  gap         : '10px',
  padding     : '10px 14px',
  textAlign   : 'left',
  transition  : 'background .1s',
  width       : '100%',
};

export default ExportButton;
